import Vue from 'vue';
import Router from 'vue-router';

import Home from '../views/Home';

Vue.use(Router);

const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error => error);
};

export default new Router({
    base: process.env.BASE_URL,
    mode:'history',
    routes: [
        {
            path: '/',
            component: Home,
        },
        {
            path: '/login',
            component: () => import('../views/Login'),
        },
        {
            path: '/register',
            component: () => import('../views/Register'),
        },
        {
            path: '/search',
            component: () => import('../views/Search'),
            meta: {
                showBreadCrumb: true,
                name: '商品列表',
            },
        },
        {
            path: '/shopcart',
            component: () => import('../views/ShopCart'),
            meta: {
                showBreadCrumb: true,
                name: '购物车',
            },
        },
        {
            path: '/sub-order',
            component: () => import('../views/SubOrder'),
            meta: {
                showBreadCrumb: true,
                name: '确认订单',
            },
        },
        {
            path: '/center',
            meta: {
                showBreadCrumb: true,
                name: '个人中心',
            },
            component: () => import('../views/Center'),
            children: [
                {
                    component: () => import('../views/center/Order'),
                    path: '/center/order',
                    meta: {
                        showBreadCrumb: true,
                        name: '我的订单',
                    },
                },
                {
                    component: () => import('../views/center/Prepay'),
                    path: '/center/prepay',
                    meta: {
                        showBreadCrumb: true,
                        name: '我的账户余额',
                    },
                },
                {
                    component: () => import('../views/center/Voucher'),
                    path: '/center/voucher',
                    meta: {
                        showBreadCrumb: true,
                        name: '我的代金券',
                    },
                },
                {
                    component: () => import('../views/center/Score'),
                    path: '/center/score',
                    meta: {
                        showBreadCrumb: true,
                        name: '我的积分',
                    },
                },
                {
                    component: () => import('../views/center/Address'),
                    path: '/center/address',
                    meta: {
                        showBreadCrumb: true,
                        name: '我的地址',
                    },
                },
                {
                    component: () => import('../views/center/InvoiceAddress'),
                    path: '/center/invoice-address',
                    meta: {
                        showBreadCrumb: true,
                        name: '我的收票地址',
                    },
                },
                {
                    component: () => import('../views/center/UserInvoice'),
                    path: '/center/user-invoice',
                    meta: {
                        showBreadCrumb: true,
                        name: '我的开票信息',
                    },
                },
                {
                    component: () => import('../views/center/WayBill'),
                    path: '/center/way-bill',
                    meta: {
                        showBreadCrumb: true,
                        name: '运单信息',
                    },
                },
                {
                    component: () => import('../views/center/UserInfo'),
                    path: '/center/userinfo',
                    meta: {
                        showBreadCrumb: true,
                        name: '我的信息',
                    },
                },
                {
                    component: () => import('../views/center/Password'),
                    path: '/center/passWord',
                    meta: {
                        showBreadCrumb: true,
                        name: '修改密码',
                    },
                },
            ],
        },
        {
            path: '/news-list',
            component: () => import('../views/NewsList'),
            meta: {
                showBreadCrumb: true,
                name: '新闻列表',
            },
        },
        {
            path: '/news/:id',
            component: () => import('../views/News'),
            meta: {
                showBreadCrumb: true,
                name: 'auto',
            },
        },
        {
            path: '/introduce/:category',
            component: () => import('../views/Introduce'),
            meta: {
                showBreadCrumb: true,
                name: 'auto',
            },
        },
        {
            path: '/score-shop',
            component: () => import('../views/ScoreShop'),
            meta: {
                showBreadCrumb: true,
                name: '积分商城',
            },
        },
        {
            path: '/hot/:type',
            component: () => import('../views/Hot'),
            meta: {
                showBreadCrumb: true,
                name: 'auto',
            },
        },
        {
            path: '/promade',
            component: () => import('../views/ProMade'),
            meta: {
                showBreadCrumb: true,
                name: '化合物定制',
            },
        },
        {
            path: '/proindex',
            component: () => import('../views/ProIndex'),
            meta: {
                showBreadCrumb: true,
                name: '索要产品目录',
            },
        },
        {
            path: '/download',
            component: () => import('../views/Download'),
            meta: {
                showBreadCrumb: true,
                name: '产品资料下载',
            },
        },
        {
            path: '/product-detail/:id',
            component: () => import('../views/ProductDetail'),
            meta: {
                showBreadCrumb: true,
                name: '商品详情',
            },
        },
        {
            path: '/product-list/:id',
            component: () => import('../views/ProductList'),
            meta: {
                showBreadCrumb: true,
                name: 'auto',
            },
        },
        {
            path: '/coa',
            component: () => import('../views/Coa'),
            meta: {
                showBreadCrumb: true,
                name: 'COA',
            },
        },        
    ],
});
